import { Minus, Plus } from "lucide-react";

export const input = "w-full rounded-xl border border-ink/20 bg-ocean px-4 py-3 text-ink outline-none focus:border-neon-cyan";
export const panel = "rounded-[2rem] border border-neon-cyan/20 bg-deep p-6 sm:p-8";
export const label = "mb-2 block font-mono2 text-[10px] uppercase tracking-[0.2em] text-neon-cyan";

export function Stepper({ value, min = 0, max = 99, onChange, testid, title }) {
    const btn = "flex h-9 w-9 items-center justify-center rounded-full border border-ink/20 text-ink transition-colors hover:border-neon-cyan hover:text-neon-cyan disabled:opacity-30";
    return (
        <div className="flex items-center gap-3">
            <button type="button" aria-label={`Remover ${title}`} data-testid={`${testid}-minus`} className={btn}
                disabled={value <= min} onClick={() => onChange(value - 1)}><Minus className="h-4 w-4" /></button>
            <span data-testid={`${testid}-value`} className="w-6 text-center font-display font-bold">{value}</span>
            <button type="button" aria-label={`Adicionar ${title}`} data-testid={`${testid}-plus`} className={btn}
                disabled={value >= max} onClick={() => onChange(value + 1)}><Plus className="h-4 w-4" /></button>
        </div>
    );
}
